import SaleContext from "contexts/SaleContext";
import { useContext } from "react";

const useSale = () => useContext(SaleContext);

export default useSale;
